import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.expertise-accordion .swiper').length) {

	const expertiseSliderMobile = new Swiper('.expertise-accordion .swiper', {
		loop: true
	});

	$('.expertise-accordion .next').on('click', function() {
		expertiseSliderMobile.slideNext();
	});

	$('.expertise-accordion .prev').on('click', function() {
		expertiseSliderMobile.slidePrev();
	});
}
